module.exports = __webpack_public_path__ + "static/hawaii-7-eb720cd1813d61a7c911a4a0fd567411.png";